import ReleaseInfoModal from './ReleaseInfoModal';

export default ReleaseInfoModal;
